import { setDefaultOptions } from 'date-fns';
import { da, de, enGB, enUS, sv, lv, pl } from 'date-fns/locale';

export function useI18nToDateFns() {
  const { locale } = useI18n();

  const dateFnsLocale = computed(() => {
    const [language, country] = locale.value.split('-');

    const locales = { da, de, enGB, enUS, sv, lv, pl };

    const languageCountryKey = language + country;

    if (isKeyOf(locales, languageCountryKey)) {
      return locales[languageCountryKey];
    }

    const languageKey = language;

    if (isKeyOf(locales, languageKey)) {
      return locales[languageKey];
    }

    return locales.da;
  });

  watch(locale, () => {
    setDefaultOptions({ locale: dateFnsLocale.value });
  }, { immediate: true });
}
